import styled from 'styled-components';

export const SaleWrapper = styled('div')``;

export const EmptyWrapper = styled('div')`
  background: white;
  padding: 15px 35px;
  border-radius: 3px;
`;
